import React from 'react';

const SvgChevronRight = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 32 32" {...props}>
    <defs>
      <path
        id="chevronRight_svg__a"
        d="M13.895 16L25 28.668 21.025 32 7 16 21.025 0 25 3.332z"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="chevronRight_svg__b" fill="#fff">
        <use xlinkHref="#chevronRight_svg__a" />
      </mask>
      <use
        fill="currentColor"
        fillRule="nonzero"
        transform="matrix(-1 0 0 1 32 0)"
        xlinkHref="#chevronRight_svg__a"
      />
    </g>
  </svg>
);

export default SvgChevronRight;
